import ReactComponent from '../app/ReactComponent'
import {Col, Image, Layout, List, Row, Space, Spin, Table, Typography} from 'antd'
import React from 'react'
import Query from '../app/Query'
import {Link} from 'react-router-dom'
import {getStoreNameByStoreId} from '../services/stores'
import {API_RESERVATION_STATE} from '../helpers/misc'
import {LeftOutlined} from '@ant-design/icons'
import {CancelRewardsButton} from '../components/buttons/CancelRewardsButton'
import App from '../app/App'

export class RewardsHistoryPage extends ReactComponent {
  state = {
    loading_page: false,
    stores: [],
    product_reservations: [],
    overview: {
      items: [],
      sorter: {
        sort_field: 'points_cost',
        sort_direction: 'asc',
        sort_fields: [
          'points_cost',
          'name'
        ]
      },
      pagination: {
        defaultCurrent: 1,
        total: 0,
        defaultPageSize: 5,
        current: 1
      },
      table: {
        headers: [
          {
            title: 'Stav',
            dataIndex: 'text_state',
            key: 'text_state'
          },
          {
            title: 'Položka',
            dataIndex: 'product_name',
            key: 'product_name'
          },
          {
            title: 'Pobočka',
            dataIndex: 'store_name',
            key: 'store_name'
          },
          {
            title: 'Možnosti',
            dataIndex: 'action',
            key: 'action'
          }
        ],
        rows: []
      }
    }
  }

  componentDidMount = async () => {
    this.pushPageAnalytics('Přehled objednávek - Moje Amber')

    void this.getPageData()
  }

  getPageData = async () => {

    const stores = await this.$app.$store('common').getStores()

    await this.updateState({
      stores: stores
    })

    void this.getRewards()

  }

  getRewards = async (offset = this.state.overview.pagination.current, sort_direction = this.state.overview.sorter.sort_direction) => {
    void this.updateState({
      loading_page: true
    })
    const query = new Query('product-reservations')

    query.add('count', this.state.overview.pagination.defaultPageSize)
    query.add('offset', (offset - 1) * this.state.overview.pagination.defaultPageSize)
    query.add('sort_field', 'last_change')
    query.add('sort_direction', 'desc')

    const {product_reservations = [], total_items = 0} = await this.$api({
      action: 'carecloud_api',
      route: query.route
    })

    const asyncProductData = async (product_id, reservation_index) => {
      let res = await this.$api({route: `products/${product_id}`})

      product_reservations[reservation_index].product = res
      product_reservations[reservation_index].product_name = res.name
    }

    for (const item of product_reservations) {
      const index = product_reservations.indexOf(item)

      item.store_name = getStoreNameByStoreId(this.state.stores, item.store_id)
      item.text_state = API_RESERVATION_STATE[item.actual_state]

      item.action = <CancelRewardsButton
        disabled={item.actual_state !== 2}
        title="Zrušit objednávku"
        description="Opravdu chcete objednávku zrušit?"
        item={item}
        onConfirm={(...args) => {
          this.cancelReservation(...args)
        }}/>

      if(item.hasOwnProperty('product_reservation_items') &&
        Array.isArray(item.product_reservation_items)) {

        for (const product of item.product_reservation_items) {
          await asyncProductData(product.reservable_product_id, index)
        }

      }

      if(item.product?.image_urls?.length > 0) {
        item.product_name = <><Image preview={false} src={item.product.image_urls[0]} style={{maxHeight: 68, maxWidth: 68, width: 'auto'}} className="mr-2"/> {item.product_name}</>
        item.image = <Image preview={false} src={item.product.image_urls[0]} style={{maxHeight: 68, maxWidth: 68, width: 'auto'}} className="mr-2"/>
      }

    }

    await this.updateState({
      loading_page: false,
      product_reservations: product_reservations,
      overview: {
        ...this.state.overview,
        pagination: {
          ...this.state.overview.pagination,
          total: total_items,
          current: offset
        }
      }
    })

    this.scrollToTop()

  }

  cancelReservation = async (item) => {

    void this.updateState({loading_page: true})

    try {

      const {product_reservation_id} = item

      await this.$api({
        action: 'carecloud_api',
        route: `product-reservations/${product_reservation_id}/actions/cancel-reservation`,
        method: 'POST'
      })

      await this.getRewards()

      App.$toast('Objednávka zrušena.')

    } catch (error) {

      console.log(error)

    } finally {

      void this.updateState({loading_page: false})

    }
  }

  render() {
    return (
      <Layout tagName={'main'} className="rewards">
        <Row align="center">
          <Col xs={24} md={24} xl={20}>
            <Space className="title-with-btn" size={[0, 0]}>
              <Link to={'/rewards'}><LeftOutlined/><span className="back-to-btn">Zpět na Amber Klub</span></Link>
              <h1>Moje objednávky</h1>
            </Space>
            <h4>Jaké odměny jste již získali?</h4>
          </Col>
          <Col xs={24} md={24} xl={20}>
            <Row className="rewards-history-item-wrapper">
              <Col xs={0} xl={24} style={{maxWidth: 1400}}>
                <Spin spinning={this.state.loading_page} size={'large'}>
                  <Table
                    className="table-reservation-overview"
                    columns={this.state.overview.table.headers}
                    dataSource={this.state.product_reservations}
                    onChange={(pagination) => this.getRewards(pagination.current)}
                    pagination={{
                      defaultCurrent: this.state.overview.pagination.defaultCurrent,
                      total: this.state.overview.pagination.total,
                      defaultPageSize: this.state.overview.pagination.defaultPageSize,
                      current: this.state.overview.pagination.current,
                      showSizeChanger: false,
                    }}
                  />
                </Spin>
              </Col>
              <Col xs={23} sm={24} xl={0} style={{maxWidth: 500}}>
                <Spin spinning={this.state.loading_page} size={'large'}>
                  <List header="Položka / Pobočka / Stav / Možnosti"
                        pagination={{
                          ...this.state.overview.pagination,
                          showSizeChanger: false,
                          onChange: (page) => this.getRewards(page)}}
                        dataSource={this.state.product_reservations} renderItem={(item) => (
                    <List.Item>
                      <Space direction="horizontal" style={{width: "100%"}}>
                        <Space direction={"vertical"}>
                          {item.image}
                        </Space>

                        <Space direction="vertical" style={{width: '100%', textAlign: 'left'}}>

                          <Typography.Text style={{fontWeight: 500}}>{item.product?.name}</Typography.Text>
                          <Space direction="horizontal" wrap>
                            <Typography.Text>{item.store_name}</Typography.Text>
                          </Space>
                          <Space direction="horizontal" className="list-tag-btn-wrapper" wrap>
                            <Typography.Text>Stav {item.text_state}</Typography.Text>
                            <Typography.Text>{item.action}</Typography.Text>
                          </Space>
                        </Space>
                      </Space>

                    </List.Item>
                  )}/>
                </Spin>
              </Col>
            </Row>
          </Col>
        </Row>
      </Layout>
    )
  }
}